import { useEffect, useState } from 'react';
import { apiGet } from '@/shared/services/api';

export interface ClientDownloadLink {
  url: string;
  label: string;
  version: string;
  sizeMb?: number | null;
  notes?: string | null;
  updatedAt?: string | null;
}

/** Topo = link do PC (os componentes antigos leem so' url/label); android = link do APK (Cabal Next, 2026-10-20). */
export interface ClientDownload extends ClientDownloadLink {
  android?: ClientDownloadLink;
}

// Cache em modulo — Home e /convite compartilham o mesmo objeto e evitam
// duas requisicoes pra mesma config.
let cached: ClientDownload | null = null;
let pending: Promise<ClientDownload> | null = null;

function fetchClientDownload(): Promise<ClientDownload> {
  if (cached) return Promise.resolve(cached);
  if (pending) return pending;
  pending = apiGet<ClientDownload>('/client-download')
    .then((r) => {
      cached = r;
      pending = null;
      return r;
    })
    .catch((e) => {
      pending = null;
      throw e;
    });
  return pending;
}

export function invalidateClientDownloadCache() {
  cached = null;
}

/**
 * Hook publico — Home e /convite consomem o link de download configurado pelo
 * master. Endpoint nao exige auth (apiGet com header vazio funciona).
 */
export function useClientDownload(): {
  data: ClientDownload | null;
  loading: boolean;
  error: string | null;
} {
  const [data, setData] = useState<ClientDownload | null>(cached);
  const [loading, setLoading] = useState<boolean>(!cached);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    if (cached) {
      setData(cached);
      setLoading(false);
      return;
    }
    fetchClientDownload()
      .then((r) => {
        if (!alive) return;
        setData(r);
        setLoading(false);
      })
      .catch((e: any) => {
        if (!alive) return;
        setError(e?.detail || e?.message || 'Erro ao carregar link');
        setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { data, loading, error };
}

/** Fallback antigo — so' se o link ainda nao foi setado no painel GM. */
const FALLBACK_DOWNLOAD_URL = 'https://drive.google.com/file/d/1heFUwDLVE4IH7Zt6x7zMrYG8oMFXzD2V/view?usp=sharing';

/** Devolve a acao "Baixar cliente": abre o link configurado (EventData.web_client_download). */
export function useOpenClientDownload() {
  const { data } = useClientDownload();
  return () => window.open(data?.url || FALLBACK_DOWNLOAD_URL, '_blank', 'noreferrer');
}
